import React from "react";
import { Card } from "@/components/ui/card";
import { inr } from "@/lib/api";
import { CalendarClock } from "lucide-react";

const TONE = {
  paid: "border-emerald-400/60 bg-emerald-500/15 text-emerald-200",
  part: "border-gold/60 bg-gold/10 text-gold",
  overdue: "border-red-400/70 bg-red-500/15 text-red-200",
  due: "border-border/60 bg-card/40 text-white/80",
};
const TXT = { paid: "Paid", part: "Part paid", overdue: "Overdue", due: "Pending" };

export const PaymentStages = ({ plan }) => {
  if (!plan) return null;
  return (
    <Card className="p-4 bg-card/40 border-gold/30" data-testid="payment-stages">
      <p className="eyebrow text-gold mb-1 flex items-center gap-1.5"><CalendarClock className="w-4 h-4" /> Payment Plan (4 stages)</p>
      <p className="text-[11px] text-muted-foreground mb-3">
        Booking ₹10,000 → 2nd ₹30,000 → 3rd ₹40,000 → final balance{plan.final_due ? `, due by ${plan.final_due} (4 days before flight)` : " 4 days before the flight"}. Wallet balance is deducted automatically.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {plan.stages.filter((s) => s.amount > 0).map((s) => (
          <div key={s.stage} data-testid={`payment-stage-${s.stage}`} className={`rounded-lg border p-2.5 ${TONE[s.status]} ${plan.current?.stage === s.stage ? "ring-2 ring-gold/60" : ""}`}>
            <p className="text-[10px] uppercase tracking-wider opacity-80">Stage {s.stage} · {s.label}</p>
            <p className="font-serif text-base text-white mt-0.5">{inr(s.amount)}</p>
            <p className="text-[11px] mt-0.5">{TXT[s.status]}{s.status === "part" ? ` · ${inr(s.remaining)} left` : ""}</p>
            {s.due_date && <p className="text-[10px] opacity-80">Due {s.due_date}</p>}
          </div>
        ))}
      </div>
    </Card>
  );
};
